/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import { ReactComponent as EditIcon } from '../../assets/images/create_24px.svg';
import { ReactComponent as SaveIcon } from '../../assets/images/save_24px.svg';
import { t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    card: {
        marginTop: '20px',
        padding: '2px',
        width: '100%',
        marginBottom: '10px',
        boxShadow: 'none',
        borderRadius: '5px',
    },
    editableCard: {
        marginTop: '10px',
        marginBottom: '20px',
        boxShadow: '0px 3px 5px rgba(0, 0, 0, 0.1), 0px 1px 18px rgba(0, 0, 0, 0.02), 0px 6px 10px rgba(0, 0, 0, 0.04)',
    },
    buttonIcon: {
        marginLeft: '8px',
    },
    cardTitle: {
        fontSize: '0.875rem',
        fontWeight: '600',
        color: theme.palette.text.outlined,
    },
    editIcon: {
        '& path': {
            fill: theme.palette.text.mainBlue,
        },
    },
    saveButton: {
        backgroundColor: theme.palette.text.mainBlue,
        color: theme.palette.text.primary,
        height: '42px',
        minWidth: '81px',
        border: 'none',
        borderRadius: '3px',
        '&:hover': {
            backgroundColor: theme.palette.text.mainBlue,
        },
    },
    cancelButton: {
        border: '1px solid ' + theme.palette.text.mainBlue,
        color: theme.palette.text.mainBlue,

        '&:hover': {
            borderColor: theme.palette.text.mainBlue,
        },
        '&:active': {
            borderColor: theme.palette.text.mainBlue,
        },
    },
}));

const Card = ({ canEdit, title, readonly, editCard, saveCard, children, cancelCard, cardId }) => {
    const classes = useStyles();

    const cardClass = !canEdit || readonly ? classes.card : `${classes.card} ${classes.editableCard}`;
    const cardButton = readonly ? (
        <Button onClick={editCard} id={`${cardId}_edit_button`}>
            {t('edit')}
            <EditIcon className={[classes.buttonIcon, classes.editIcon].join(' ')} aria-hidden="true" focusable="false" />
        </Button>
    ) : (
        <>
            {cancelCard && (
                <Button className={classes.cancelButton} variant="outlined" onClick={cancelCard} id={`${cardId}_cancel_button`}>
                    {t('cancel')}
                </Button>
            )}
            <Button className={classes.saveButton} variant="contained" onClick={saveCard} id={`${cardId}_save_button`}>
                {t('save')}
                <SaveIcon className={classes.buttonIcon} aria-hidden="true" focusable="false" />
            </Button>
        </>
    );

    return (
        <div className={cardClass}>
            <Grid justify="space-between" alignItems="center" container>
                {title && (
                    <Grid item>
                        <Typography className={classes.cardTitle}>{t(title)}</Typography>
                    </Grid>
                )}
                {canEdit && <Grid item>{cardButton}</Grid>}
            </Grid>
            <div>{children}</div>
        </div>
    );
};

export default Card;
